const ROUTE_FAMILY_ALIASES: Array<{ pattern: RegExp; canonical: string }> = [
    { pattern: /^\/legacy\/inquiries(?:\/.*)?$/i, canonical: '/inquiries' },
    { pattern: /^\/sales\/inquiries(?:\/.*)?$/i, canonical: '/inquiries' },
    { pattern: /^\/inquiries(?:\/.*)?$/i, canonical: '/inquiries' },
    { pattern: /^\/legacy\/orders(?:\/.*)?$/i, canonical: '/sales/orders' },
    { pattern: /^\/sales\/orders(?:\/.*)?$/i, canonical: '/sales/orders' },
    { pattern: /^\/orders(?:\/.*)?$/i, canonical: '/sales/orders' },
    { pattern: /^\/legacy\/delivery(?:\/.*)?$/i, canonical: '/delivery' },
    { pattern: /^\/sales\/delivery(?:\/.*)?$/i, canonical: '/delivery' },
    { pattern: /^\/delivery(?:\/.*)?$/i, canonical: '/delivery' },
    { pattern: /^\/legacy\/invoices(?:\/.*)?$/i, canonical: '/sales/invoices' },
    { pattern: /^\/sales\/invoices(?:\/.*)?$/i, canonical: '/sales/invoices' },
    { pattern: /^\/financials(?:\/.*)?$/i, canonical: '/financials' },
    { pattern: /^\/reports(?:\/.*)?$/i, canonical: '/reports' },
    { pattern: /^\/manufacturing(?:\/.*)?$/i, canonical: '/manufacturing' },
    { pattern: /^\/inventory(?:\/.*)?$/i, canonical: '/inventory' },
    { pattern: /^\/materials(?:\/.*)?$/i, canonical: '/materials' },
    { pattern: /^\/purchasing\/orders(?:\/.*)?$/i, canonical: '/purchasing/orders' },
    { pattern: /^\/purchasing\/grn(?:\/.*)?$/i, canonical: '/purchasing/grn' },
    { pattern: /^\/legacy\/grn(?:\/.*)?$/i, canonical: '/purchasing/grn' },
    { pattern: /^\/purchasing\/bills(?:\/.*)?$/i, canonical: '/purchasing/bills' },
    { pattern: /^\/legacy\/estimates(?:\/.*)?$/i, canonical: '/legacy/estimates' },
    { pattern: /^\/legacy\/customers(?:\/.*)?$/i, canonical: '/legacy/customers' },
    { pattern: /^\/legacy\/suppliers(?:\/.*)?$/i, canonical: '/legacy/suppliers' },
];

function stripQueryAndHash(path: string): string {
    return String(path || '')
        .split(/[?#]/, 1)[0]
        .trim()
        .replace(/\/+$/, '') || '/';
}

export function canonicalizeNavigationPath(path: string): string {
    const normalized = stripQueryAndHash(path);
    for (const alias of ROUTE_FAMILY_ALIASES) {
        if (alias.pattern.test(normalized)) {
            return alias.canonical;
        }
    }
    return normalized;
}

export function navigationPathsEqual(left: string, right: string): boolean {
    return canonicalizeNavigationPath(left) === canonicalizeNavigationPath(right);
}

export function isNavigationPathAllowed(path: string, allowedRoots: Set<string>): boolean {
    return allowedRoots.has(canonicalizeNavigationPath(path));
}

export function findNavigationMatchByPath<T extends { to: string }>(items: T[], path: string): T | undefined {
    return items.find((item) => navigationPathsEqual(item.to, path));
}
